<template>
  <div
    v-if="icons"
    class="payment-method-icons"
  >
    <div class="flex flex-col">
      <div class="payment-method-icons__wrapper flex gap-x-2 gap-y-3 flex-wrap">
        <PaymentIcon
          v-for="icon in icons"
          :key="icon.alt"
          :icon="icon"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import type { PaymentMethodIcon } from '~~/types/cms/PaymentIcons';

export default defineComponent({
  name: 'PaymentMethodIcons',

  props: {
    icons: {
      type: Array as PropType<PaymentMethodIcon[]>,
      required: true,
    },
  },
});

</script>
